<template>
    <div class="erow">
        <div class="erow-l">
            <el-row :gutter="20" :data="infoData">
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <div class="label">
                            分公司：
                            <span
                                class="value"
                                :title="infoData.companyName"
                            >{{infoData.companyName}}</span>
                        </div>
                        <div class="label">
                            服务平台：
                            <span
                                class="value"
                                :title="infoData.siteName"
                            >{{infoData.siteName}}</span>
                        </div>
                        <div class="label">
                            会计主体：
                            <span
                                class="value"
                                :title="infoData.ledgerName"
                            >{{infoData.ledgerName}}</span>
                        </div>
                        <div class="label">
                            应收转押金金额：
                            <span
                                class="value"
                                :title="infoData.payChangeCashAmt"
                            >{{infoData.payChangeCashAmt}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <div class="label">
                            业务类型：
                            <span
                                class="value"
                                :title="infoData.businessProperty"
                            >{{infoData.businessProperty}}</span>
                        </div>
                        <!-- <div class="label">
                            押金类型：
                            <span
                                class="value"
                                :title="infoData.suppliersCashType"
                            >{{infoData.suppliersCashType}}</span>
                        </div> -->
                        <div class="label" v-if="isContractName">
                            合同名称：
                            <span
                                class="value"
                                :title="infoData.contractName"
                            >{{infoData.contractName}}</span>
                        </div>
                        <div class="label">
                            合同状态：
                            <span class="value" :title="infoData.statusText">{{infoData.statusText}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <div class="label">
                            罚扣款金额：
                            <span
                                class="value"
                                :title="infoData.penaltyAmt"
                            >{{infoData.penaltyAmt}}</span>
                        </div>
                        <div class="label">
                            实际退款：
                            <span
                                class="value"
                                :title="infoData.actualRefund"
                            >{{infoData.actualRefund}}</span>
                        </div>
                        <div class="label">
                            计划退款：
                            <span
                                class="value"
                                :title="infoData.theReturnAmt"
                            >{{infoData.theReturnAmt}}</span>
                        </div>
                        <div class="label">
                            现汇金额：
                            <span
                                class="value"
                                :title="infoData.toAmt"
                            >{{infoData.toAmt}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <div class="label">
                            币种：
                            <span class="value" :title="infoData.currencyCode">{{infoData.currencyCode}}</span>
                        </div>
                        <div class="label">
                            创建日期：
                            <span class="value" :title="infoData.createTime">{{infoData.createTime}}</span>
                        </div>
                         <div class="label">
                            备注：
                            <span class="value" :title="infoData.remark">{{infoData.remark}}</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="erow-r">
            <div class="left-label">
                <div class="prices-t">{{infoData.budgetAmt ? infoData.budgetAmt : 0}} <span class="prices-m">元</span></div>
                <div class="texts-t">押金金额</div>
            </div>
            <div class="left-value">
                <div class="prices-b">{{infoData.balanceAmt ? infoData.balanceAmt : 0}} <span class="prices-m">元</span></div>
                <div class="texts-b">余额</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        infoData: {
            type: Object
        },
        isContractName: {
            type: Boolean,
            default: true
        },
        isTendering: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            data: {}
        };
    }
};
</script>

<style lang="less">
.erow {
    display: flex;
    .erow-l {
        flex: 6;
    }
    .erow-r {
        flex: 3;
        display: flex;
        text-align: center;
    }
    .left-label,
    .left-value {
        flex: 3;
    }
    .prices-t,
    .prices-b {
        color: #FF8800;
        font-size: 24px;
        margin-top: 38px;
    }
    .texts-t,
    .texts-b {
        font-size: 14px;
        color: #333;
        margin-top: 8px;
    }
    .prices-m {
        color:#000;
        font-size: 14px;
    }
}
</style>